import { useQuery } from '@tanstack/react-query'
import { OTP_PROVIDER_QUERY_KEYS } from '@/modules/otp-provider/constants'
import { OtpProviderService } from '@/modules/otp-provider/api/services'
import type { paths } from '@/schema'

type OtpProviderResponse =
	paths['/api/admin/otp-provider/{id}']['get']['responses']['200']['content']['application/json']

const useQueryGetOtpProvider = (id: string) => {
	return useQuery<OtpProviderResponse>({
		queryKey: OTP_PROVIDER_QUERY_KEYS.PROVIDERS.DETAIL(id),
		queryFn: () => OtpProviderService.getOtpProvider(id),
		enabled: !!id,
	})
}

export default useQueryGetOtpProvider
